import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconDocumentText from '@/assets/icons/heroIcons/DocumentText.svg';
import { DownloadButton } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
export function OtherDocuments() {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["otherDocuments"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] !== isCsLanguage || $[2] !== locale || $[3] !== t) {
    t1 = isCsLanguage ? [{
      path: FILES(locale).cashbackRules,
      title: t("categories.1.documents.cashbackRules"),
      id: "cashbackRules"
    }, {
      path: FILES(locale).loyaltyProgramRules,
      title: t("categories.1.documents.loyaltyProgramRules"),
      id: "loyaltyProgramRules"
    }, {
      path: FILES(locale).conditionsForObtainingExtraRewardPoints,
      title: t("categories.1.documents.conditionsForObtainingExtraRewardPoints"),
      id: "conditionsForObtainingExtraRewardPoints"
    }, {
      path: FILES(locale).conditionsFor12x100,
      title: t("categories.1.documents.conditionsFor12x100"),
      id: "conditionsFor12x100"
    }, {
      path: FILES(locale).complaintsProcedure,
      title: t("categories.1.documents.complaintsProcedure"),
      id: "complaintsProcedure"
    }, {
      path: FILES(locale).yourRightsWhenMakingPaymentsInEurope,
      title: t("categories.1.documents.yourRightsWhenMakingPaymentsInEurope"),
      id: "yourRightsWhenMakingPaymentsInEurope"
    }, {
      path: "/files/cs/Skippay_Pojisteni_prodlouzene_zaruky.pdf",
      title: t("categories.1.documents.insurance"),
      id: "purchaseInsuranceConditions"
    }, {
      path: "/files/cs/VPP_PK_2021.pdf",
      title: t("categories.1.documents.insuranceConditions"),
      id: "insuranceConditions"
    }] : [{
      path: FILES(locale).complaintsProcedure,
      title: t("categories.1.documents.complaintsProcedure"),
      id: "complaintsProcedure"
    }];
    $[1] = isCsLanguage;
    $[2] = locale;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const documents = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("categories.1.title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconDocumentText className="h-7 w-7 text-blue-500 lg:h-10 lg:w-10" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("categories.1.text");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <p className="mb-8">{t4}</p>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("categories.1.documents.title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <h3 className="mb-4 text-base font-bold lg:mb-6 lg:text-2xl">{t6}</h3>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== documents) {
    t8 = <div className="inline-block">{documents.map(_temp)}</div>;
    $[16] = documents;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t7 || $[21] !== t8) {
    t9 = <DocumentSection title={t2} icon={t3} isDropdown={false}>{t5}{t7}{t8}</DocumentSection>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp(t0) {
  const {
    path,
    title,
    id
  } = t0;
  return <div className="mb-2 lg:mb-4" key={id}><DownloadButton to={path} testId={id} analyticsParam={id} className="sm:w-full">{title}</DownloadButton></div>;
}